import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../../lib/api";
import { BTN, INPUT, errMsg } from "../../components/crm/crmUtil";

// B5 part 2b: client signing page. Consent screen first (pending legal review), then the document with its version and
// SHA-256; the signature is accepted only if the server's document still matches what is shown here.
export default function ClientSign() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [agree, setAgree] = useState(false);
  const [name, setName] = useState("");
  const [state, setState] = useState({ err: "", done: false });
  const load = () => api.get(`/sales/public/sign/${token}`).then((r) => setD(r.data)).catch((e) => setState({ err: errMsg(e), done: false }));
  useEffect(() => { load(); }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const consent = async () => { try { await api.post(`/sales/public/sign/${token}/consent`, { agree: true, consent_version: d.consent_version }); load(); } catch (e) { setState({ err: errMsg(e), done: false }); } };
  const sign = async (e) => {
    e.preventDefault();
    try { await api.post(`/sales/public/sign/${token}/sign`, { typed_name: name.trim(), document_sha256: d.document_sha256, document_version: d.document_version }); setState({ err: "", done: true }); }
    catch (x) { setState({ err: errMsg(x), done: false }); }
  };
  return (
    <main className="min-h-screen bg-erf-cream px-4 py-8" data-testid="client-sign">
      <div className="mx-auto max-w-3xl space-y-4">
        <h1 className="font-display text-2xl font-semibold">{d?.company || "Document"} — signature</h1>
        {state.err && <p role="alert" className="text-sm text-red-700" data-testid="sign-error">{state.err}</p>}
        {state.done && <p role="status" className="text-green-800" data-testid="sign-done">Signed. Your contractor will send you the signed copy.</p>}
        {d && !state.done && !d.consented && (
          <section className="bg-white border border-erf-borderCream rounded p-4 space-y-3" data-testid="consent-screen">
            <h2 className="font-semibold">Consent to sign electronically</h2>
            <p className="text-sm" data-testid="consent-text">{d.consent_text}</p>
            <label htmlFor="consent-agree" className="flex items-center gap-2 min-h-[44px] text-sm">
              <input id="consent-agree" type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} className="w-5 h-5" data-testid="consent-agree" />
              I agree to sign electronically.
            </label>
            <button type="button" disabled={!agree} onClick={consent} className={`${BTN} bg-erf-dark text-white`} data-testid="consent-submit">Continue</button>
          </section>
        )}
        {d && !state.done && d.consented && (
          <>
            <section className="bg-white border border-erf-borderCream rounded p-4" data-testid="sign-document">
              <p className="text-xs font-mono break-all" data-testid="sign-integrity">Version {d.document_version} · SHA-256 {d.document_sha256}</p>
              <pre className="whitespace-pre-wrap text-sm mt-3">{d.document_text}</pre>
            </section>
            {!d.identity_verified ? (
              <p className="text-sm" data-testid="sign-identity-pending">Before you can sign, your contractor needs to verify your identity (in person or by phone).</p>
            ) : (
              <form onSubmit={sign} className="bg-white border border-erf-borderCream rounded p-4 space-y-2" data-testid="sign-form">
                <p className="text-xs" data-testid="sign-identity">{d.identity_label}</p>
                <label htmlFor="sign-name" className="text-sm block">Type your full name to sign<input id="sign-name" value={name} onChange={(e) => setName(e.target.value)} className={INPUT} data-testid="sign-name" /></label>
                <button type="submit" disabled={name.trim().length < 2} className={`${BTN} bg-erf-gold text-erf-dark`} data-testid="sign-submit">Sign</button>
              </form>
            )}
          </>
        )}
        {d && <p className="text-xs text-erf-dark/60" data-testid="sign-notice">{d.notice}</p>}
      </div>
    </main>
  );
}
